import { render, staticRenderFns } from "./XmBackToTop.vue?vue&type=template&id=a4f9dbac&scoped=true"
import script from "./XmBackToTop.vue?vue&type=script&lang=js"
export * from "./XmBackToTop.vue?vue&type=script&lang=js"
import style0 from "./XmBackToTop.vue?vue&type=style&index=0&id=a4f9dbac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f9dbac",
  null
  
)

export default component.exports